module.exports = __webpack_public_path__ + "img/diners-club.092a7fd2.svg";